import type { FreeSlot } from '@hedepy/common/schemas/modules/schedule/freeSlot'
import { type Dayjs } from 'dayjs'

import { type ServiceType } from '@/legacy-src/types/GeneralStateType'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

import { ClientBookingDaySlots } from '@/src/domains/client-booking/components/ClientBookingDaySlots'

import { ClientBookingAvailableSlot } from './ClientBookingAvailableSlot'

interface ClientBookingAvailableSlotsUIProps {
  day: Dayjs
  service: ServiceType
  therapist: TherapistType
  slots: FreeSlot[]
}

export const ClientBookingAvailableSlotsUI = ({
  day,
  service,
  therapist,
  slots,
}: ClientBookingAvailableSlotsUIProps) => {
  return (
    <ClientBookingDaySlots day={day} duration={service.duration}>
      <div className="flex flex-wrap gap-3">
        {slots.map((slot) => (
          <ClientBookingAvailableSlot key={slot.id} therapist={therapist} slot={slot} service={service} />
        ))}
      </div>
    </ClientBookingDaySlots>
  )
}
